import { render, staticRenderFns } from "./FinancesForm.vue?vue&type=template&id=45e41c1e"
import script from "./FinancesForm.vue?vue&type=script&lang=ts"
export * from "./FinancesForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports